package amazon.lastmile.inject

import app.nestbridge.domain.identity.api.RemoteUserProfileApiClient
import app.nestbridge.domain.identity.api.UserProfileApiClient
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = RemoteUserProfileApiClient::class)
public interface AppNestbridgeDomainIdentityApiRemoteUserProfileApiClient {
  @Provides
  public fun provideRemoteUserProfileApiClientUserProfileApiClient(remoteUserProfileApiClient: RemoteUserProfileApiClient): UserProfileApiClient = remoteUserProfileApiClient
}
